import React, { useState } from 'react'
import Button from '../../../Components/Button'
import { formatPrice } from '../utils/formatters'

export default function ShareButton({ orderRef, order, account, onSuccess, onCopySuccess, onError }) {
  const [isSharing, setIsSharing] = useState(false)

  const handleShare = async () => {
    setIsSharing(true)
    const orderText = buildOrderText(order, account)

    try {
      // Try native share API (works well on mobile)
      if (navigator.share) {
        await navigator.share({
          title: `Order #${order.order_number}`,
          text: orderText
        })
        onSuccess?.()
        return
      }

      // Fallback: copy to clipboard
      await navigator.clipboard.writeText(orderText)
      onCopySuccess?.()
    } catch (err) {
      // User cancelled share - not an error
      if (err.name === 'AbortError') {
        return
      }

      // Clipboard might fail in some contexts, try execCommand fallback
      try {
        const textArea = document.createElement('textarea')
        textArea.value = orderText
        textArea.style.position = 'fixed'
        textArea.style.opacity = '0'
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        onCopySuccess?.()
      } catch (fallbackErr) {
        console.error('Share failed:', err, fallbackErr)
        onError?.()
      }
    } finally {
      setIsSharing(false)
    }
  }

  const buildOrderText = (order, account) => {
    const items = order.order_items
      .map(item => `${item.quantity}x ${item.menu_item.name} - ${formatPrice(item.line_total_pence)}`)
      .join('\n')

    const codeLine = order.order_code ? `Order Code: ${order.order_code}\n` : ''

    return `${codeLine}Order #${order.order_number}
${account.name}

${items}

Total: ${formatPrice(order.total_pence)}`
  }

  return (
    <Button
      onClick={handleShare}
      variant="secondary"
      theme="dark"
      size="lg"
      fullWidth
      disabled={isSharing}
      className="shadow-lg"
      ariaLabel="Share order"
    >
      {isSharing ? 'Sharing...' : 'Share Order'}
    </Button>
  )
}
